import { httpRequest } from "../../http";
import { CatalogEntityType, EntityTypeIn } from "@models/catalog.model";

const COLL = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/catalog/entity-types/`;

export class CommandCreateEntityType {
  async run(payload: EntityTypeIn): Promise<CatalogEntityType> {
    return httpRequest<CatalogEntityType>(COLL, { method: "POST", body: payload });
  }
}

export class CommandUpdateEntityType {
  async run(id: number, payload: EntityTypeIn): Promise<CatalogEntityType> {
    return httpRequest<CatalogEntityType>(`${COLL}${id}/`, { method: "PUT", body: payload });
  }
}

export class CommandDeleteEntityType {
  async run(id: number): Promise<void> {
    await httpRequest(`${COLL}${id}/`, { method: "DELETE" });
  }
}
